import { Button, FloatingLabel, Form, Modal } from "react-bootstrap";


export default function IsicomConsole (props) {

    function getLogs() {
        return sessionStorage.getItem("isicom_logs");
    }

    return (
        <>
            <Modal show={props.show ?? false} onHide={() => props.onHide()}>
                <Modal.Header closeButton>
                    <Modal.Title>Console isicom</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form>
                        <FloatingLabel label="Logs">
                            <Form.Control as="textarea" style={{height: '500px'}}>{getLogs()}</Form.Control>
                        </FloatingLabel>
                    </Form>
                </Modal.Body>
            </Modal>
        </>
    );
}
